<div class="forget-password-container">
  <div class="forget-password-card">
    <!-- Header -->
    <div class="forget-password-header">
      <div class="brand-section">
        <img src="/vat-logo.png" alt="VAT Logo" class="vat-logo">
        <h2 class="brand-title">VAT E-Service</h2>
      </div>
      <h1 class="forget-password-title">ลืมรหัสผ่าน</h1>
      <p class="forget-password-subtitle">กรอกอีเมลและรหัสบัตรประชาชนเพื่อรีเซ็ตรหัสผ่าน</p>
    </div>

    <!-- Success Message -->
    <div class="alert alert-success" *ngIf="successMessage">
      <i class="bi bi-check-circle-fill"></i>
      <div>
        <strong>สำเร็จ!</strong>
        <p>{{ successMessage }}</p>
        <p class="mb-0"><small>กำลังนำท่านไปหน้าเข้าสู่ระบบ...</small></p>
      </div>
    </div>

    <!-- Error Message -->
    <div class="alert alert-danger" *ngIf="errorMessage">
      <i class="bi bi-exclamation-triangle-fill"></i>
      <div>
        <strong>เกิดข้อผิดพลาด!</strong>
        <p class="mb-0">{{ errorMessage }}</p>
      </div>
    </div>

    <!-- Form -->
    <form [formGroup]="forgetPasswordForm" (ngSubmit)="onSubmit()" class="forget-password-form" *ngIf="!successMessage">
      <div class="form-section">
        <h3 class="section-title">
          <i class="bi bi-key-fill"></i>
          ข้อมูลสำหรับรีเซ็ตรหัสผ่าน
        </h3>

        <!-- Email -->
        <div class="mb-4">
          <label class="form-label required">อีเมล</label>
          <div class="input-group">
            <span class="input-group-text">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                <polyline points="22,6 12,13 2,6"></polyline>
              </svg>
            </span>
            <input 
              type="email" 
              class="form-control" 
              formControlName="email" 
              [class.is-invalid]="hasError('email')" 
              placeholder="example@email.com"
              autocomplete="email">
          </div>
          <div class="invalid-feedback" *ngIf="hasError('email')">
            {{ getErrorMessage('email') }}
          </div>
        </div>

        <!-- CID -->
        <div class="mb-4">
          <label class="form-label required">รหัสบัตรประชาชน</label>
          <div class="input-group">
            <span class="input-group-text">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
            </span>
            <input 
              type="text" 
              class="form-control" 
              formControlName="cid" 
              [class.is-invalid]="hasError('cid')" 
              placeholder="กรอกรหัสบัตรประชาชน 13 หลัก"
              maxlength="13"
              autocomplete="off">
          </div>
          <div class="invalid-feedback" *ngIf="hasError('cid')">
            {{ getErrorMessage('cid') }}
          </div>
        </div>

        <!-- Info Alert -->
        <div class="alert alert-info">
          <i class="bi bi-info-circle-fill"></i>
          <div>
            <strong>หมายเหตุ:</strong> หลังจากรีเซ็ตรหัสผ่านแล้ว รหัสผ่านใหม่จะถูกส่งไปยังอีเมลของท่าน กรุณาตรวจสอบอีเมลและเข้าสู่ระบบด้วยรหัสผ่านใหม่
          </div>
        </div>
      </div>

      <!-- Form Actions -->
      <div class="form-actions">
        <button type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSubmitting">
          <i class="bi bi-x-circle"></i>
          ยกเลิก
        </button>
        <button type="submit" class="btn btn-primary" [disabled]="isSubmitting">
          <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm me-2"></span>
          <i *ngIf="!isSubmitting" class="bi bi-key"></i>
          {{ isSubmitting ? 'กำลังรีเซ็ตรหัสผ่าน...' : 'รีเซ็ตรหัสผ่าน' }}
        </button>
      </div>
    </form>

    <!-- Footer -->
    <div class="forget-password-footer">
      <p>จำรหัสผ่านได้แล้ว? <a routerLink="/login" class="login-link">เข้าสู่ระบบ</a></p>
      <p>ยังไม่มีบัญชี? <a routerLink="/pre-register" class="register-link">ลงทะเบียนเบื้องต้น</a></p>
      <p class="copyright">© 2026 VAT E-Service. All rights reserved.</p>
    </div>
  </div>
</div>
